import { core_v1_DataSource_FieldUtils } from '@antimatterhq/asl-api-ts-v1';
import { filterStringArray } from './datasourceUtils';
import {
  EmbedColumnType,
  PreserveUnreferencedColumnsSchemaValues,
} from '@/zod/schemas/dataSource/Common';

export const getPreserveUnreferencedColumnsValues = (
  utils?: core_v1_DataSource_FieldUtils | null,
): PreserveUnreferencedColumnsSchemaValues => {
  return {
    preserve: utils?.unreferencedColumns?.preserve ?? false,
    embed: !!utils?.unreferencedColumns?.embedColumn,
    embedColumn: utils?.unreferencedColumns?.embedColumn ?? '',
    embedColumnType: (utils?.unreferencedColumns?.embedColumnType ??
      '') as EmbedColumnType,
    duplicatePrefix: utils?.unreferencedColumns?.duplicatePrefix ?? '',
    omitColumns: utils?.unreferencedColumns?.omitColumns ?? [''],
  };
};

export const setPreserveUnreferencedColumns = (
  preserveUnreferencedColumnsValues: PreserveUnreferencedColumnsSchemaValues,
): NonNullable<core_v1_DataSource_FieldUtils>['unreferencedColumns'] => {
  const {
    preserve,
    embed,
    embedColumn,
    embedColumnType,
    duplicatePrefix,
    omitColumns,
  } = preserveUnreferencedColumnsValues;
  if (!preserve) {
    return {
      preserve: false,
    };
  }

  return {
    preserve: true,
    embedColumn: embed ? embedColumn : undefined,
    embedColumnType: embed ? embedColumnType : undefined,
    duplicatePrefix: !embed ? duplicatePrefix || undefined : undefined,
    omitColumns: filterStringArray(omitColumns),
  };
};
